import { CommonUser } from '../../../../entities/Common'

export const mapManagerNamesToIds = (
	managerNames: string[],
	commonUsers: CommonUser[]
) => managerNames.reduce(
	(acc: { id: string }[], managerName) => {
		const user = commonUsers.find((user) => {
			return user.fullName === managerName
		})
		if (user) acc.push({ id: user.userId })
		return acc
	},
	[]
)
